import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { DeleteSubProductComponent } from './delete-sub-product/delete-sub-product.component';

@Component({
  selector: 'app-manage-sub-product',
  templateUrl: './manage-sub-product.component.html',
  styleUrls: ['./manage-sub-product.component.scss'],
})
export class ManageSubProductComponent implements OnInit {
  subProductForm: FormGroup;
  productId: any;
  subProductData: any;
  selectedItems: any = [];

  constructor(
    private fb: FormBuilder,
    private userService: UserManagementService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageSubProductComponent>
  ) {}

  formInIt() {
    this.subProductForm = this.fb.group({
      subProductName: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
    });
  }

  ngOnInit(): void {
    this.productId = sessionStorage.getItem('marketProductId');
    this.formInIt();

    this.getSubProductdata();
  }

  getSubProductdata() {
    this.userService.getSubProductType(this.productId).subscribe((res: any) => {
      this.subProductData = res.result.data;
    });
  }

  onSubmit() {
    let body: any = {
      productID: this.productId,
      subProductName: this.subProductForm.value.subProductName,
    };

    if(this.subProductForm.valid){
      this.userService.addSubMarketProduct(body).subscribe(
        (res: any) => {
          res.result.data == 1
            ? this.toastr.success(res.result.message)
            : this.toastr.error(res.result.message);
          this.getSubProductdata();
          this.subProductForm.reset();
        },
        (err) => {}
      );
    }else{
      this.toastr.error("Please fill the sub product name")
    }
  }

  deleteSubProduct() {
    if (this.selectedItems?.length > 0) {
      const dialogRef = this.dialog.open(DeleteSubProductComponent, {
        width: '35%',
        height: '36%',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.result === 'Yes') {
          const selectedArr = this.selectedItems.map((ele) => {
            return { subProductTypeID: ele, remark: result.remark };
          });
          const deleteBody = {
            removeSubProductType: selectedArr,
          };
          this.userService.deleteSubProduct(deleteBody).subscribe((data) => {
            if (data['result'].data == 1) {
              // const arrayData = this.subProductData.filter(
              //   (obj: any) => !this.selectedItems.includes(obj.subProductTypeCode)
              // );
              // this.subProductData = arrayData as any;
              this.getSubProductdata();
              this.toastr.success(data['result'].message, 'Success', {
                timeOut: 3000,
              });
              this.selectedItems = [];
            }
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one Sub Product!', 'Info', {
        timeOut: 3000,
      });
    }
  }

  itemToDelete(id, event: any) {
    if (event.checked) {
      this.selectedItems.push(id);
    } else {
      const idArray = this.selectedItems.indexOf(id);
      this.selectedItems.splice(idArray, 1);
    }
  }

  closeModal() {
    this.dialogRef.close();
    // setTimeout("location.reload(true);", 500);
    this.router.navigate(['/MarketPlace']);
  }
}
